export const EXPORT_LABEL_CSV = "Download as CSV";
export const EXPORT_LABEL_XLSX = "Download as Excel";

export const FILE_EXT_CSV = "csv";
export const FILE_EXT_XLSX = "xlsx";

export const DEFAULT_BUTTON_CONFIGS = {
  [EXPORT_LABEL_CSV]: FILE_EXT_CSV,
  [EXPORT_LABEL_XLSX]: FILE_EXT_XLSX,
};

export const ITEMS_PER_FILE_BY_FILE_TYPE = {
  [FILE_EXT_XLSX]: 40000,
};

export const DEFAULT_ITEMS_PER_PAGE = 2000;

export const XLSX_TRUNCATE_LIMIT = 32767;

const TWO_MINUTES = 2 * 60 * 1000;
export const QUEUE_STUCK_TIMEOUT = TWO_MINUTES;

export const API_RETRY_COUNT = 1;

export const WORKER_TOPIC_TRANSFORM = "merge-chunk";
export const WORKER_TOPIC_GET_BLOB = "generate-blob";

export const DATE_FORMAT_FOR_FILENAME = "YYYY-MM-DD_HH-mm-ss";

export const REJECT_REASON_API = "API Failures";
export const REJECT_REASON_UNMOUNT = "Component Unmounted";
export const REJECT_REASON_TIMEOUT = "Timeout";
export const REJECT_REASON_ABORT = "Export aborted";
